import TemplateBuilder from "../../../main/templates/TemplateBuilder";
import EditCertificate from "../../../main/certificates/EditCertificate";
import { Link } from "react-router-dom";
import { Api } from "../../../../helpers/Api";
import { option } from "../../../../helpers/DropDownOption";
import FileUpload from "../../Components/FileUpload/FileUpload";
import Moment from 'moment';
import Papa from "papaparse";
import { useNavigate } from "react-router-dom";
import { read, utils } from 'xlsx';
import { get } from "http";
import { access } from "fs";
import NewIicReport from "../../Components/PDF/NewIicReport";
import { type } from "os";
import { title } from "process";


const dateFormat = 'DD/MM/YYYY';
const columnConfig = {
    editIcon: <img width="16px" src="../../../images/edit.svg" alt="edit" />,
    deleteIcon: <img width="16px" src="../../../images/delete.svg" alt="edit" />,
    downloadIcon: <img width="16px" src="../../../images/download.svg" alt="download" />,

    brands: {
        url: "brands",
        name: "Schools",
        columns: [
            { name: "Name", key: "name" },
            {
                name: "Department", accessor: (object) => {
                    return object?.departments.length;
                }
            },
            {
                name: "Created By", accessor: (object) => {
                    return object?.owner?.name;
                }
            },
            {
                name: "Updated At", accessor: (object) => {
                    return Moment(object?.updated_at.substr(0, 10)).format(dateFormat);
                }
            },
            { name: "Actions", key: "actions" },
        ],
        form: [
            {
                name: "Name", key: "name", type: 'text', required: true
            },
            {
                name: "Email", key: "email", type: 'text', validations:
                    [
                        { validator: 'schoolemail', error: 'We support only @chitkara.edu.in domain emails' }
                    ], required: true
            },
        ]
    },
    departments: {
        url: "departments",
        name: "Departments",
        columns: [
            {
                name: "Name", accessor: (object) => {
                    return object.name
                }
            },
            {
                name: "School", accessor: (object) => {
                    if (object?.brand?.name) {
                        return object?.brand?.name
                    }
                    else {
                        return "No School";
                    }
                }
            },
            {
                name: "Created By", accessor: (object) => {
                    return object?.owner?.name;
                }
            },
            {
                name: "Updated At", accessor: (object) => {
                    return Moment(object?.updated_at.substr(0, 10)).format(dateFormat);
                }
            },
            { name: "Actions", key: "actions" },
        ],
        form: [
            {
                name: "Name", key: "name", type: 'text', required: true
            },

            {
                name: "School",
                key: "brand",
                type: 'select',
                options: [],
                fetchOptions: { url: "/brands", key: "id", label: "name" },
                required: true,
            },
        ]
    },
    users: {
        url: "users",
        name: "Users",
        columns: [
            { name: "Name", key: "name" },
            { name: "Email", key: "email" },
            {
                name: "Disable Login", accessor: (object) => {
                    return <Link to='#' onClick={() => {
                        Api.call(`/userblock/${object.id}`)
                        let link = new Link();
                        link.to = "users";

                    }}>{object.blocked ? 'Enable logIn' : 'Disable LogIn'}</Link>
                }
            },
            {
                name: "Role", accessor: (object) => {
                    return `${object?.role?.name}`;
                }
            },
            {
                name: "School", accessor: (object) => {
                    if (object.brands.length !== 0) {
                        return (
                            <p className="users-td-para">
                                {object.brands.map((brand, index) => {
                                    if (index === object.brands.length - 1) {
                                        return `${brand.name}`;
                                    }
                                    return `${brand.name}, `;
                                })}
                            </p>
                        )
                    }
                    else {
                        return <p className="users-td-para" style={{ color: "green" }}>No School</p>;
                    }
                }
            },
            {
                name: "Department", accessor: (object) => {
                    if (object.departments.length !== 0) {
                        return (
                            <p className="users-td-para">
                                {object.departments.map((department, index) => {
                                    if (index === object.departments.length - 1) {
                                        return `${department.name}`;
                                    }
                                    return `${department.name}, `;
                                })}
                            </p>
                        )
                    }
                    else {
                        return <p className="users-td-para" style={{ color: "green" }}>No Departments</p>;
                    }
                }
            },

            {
                name: "Updated At", accessor: (object) => {
                    return Moment(object?.updated_at.substr(0, 10)).format(dateFormat);
                }
            },
            { name: "Actions", key: "actions" },
        ],
        form: [
            {
                name: "Name", key: "name", type: 'text', validations:
                    [
                        { validator: 'stringWithSpace', error: 'Please enter only alphabetical letters' }
                    ], required: true
            },

            { name: "Username", key: "username", required: true },
            {
                name: "Email", key: "email", required: true
            },
            {
                name: "Contact Number", key: "Contact", validations:
                    [
                        { validator: 'ContactNumber', error: 'Enter valid contact number' }
                    ],
                required: true
            },
            { name: "Password", key: "password" },

            {
                name: "Role", key: "role", type: 'select', options: [{ value: 2, label: 'Staff' },
                { value: 1, label: 'Super Admin' },
                { value: 3, label: 'Dean' },
                { value: 4, label: 'Admin' },
                { value: 5, label: 'Teacher' },
                { value: 6, label: 'DR-IQAC' },
                { value: 12, label: 'IIC Admin' },
                { value: 13, label: 'Rise-Event Admin' },
                { value: 7, label: 'Director' }]
            },
            {
                name: "School",
                key: "brands",
                // required: true,
                type: 'usermultiselect',
                options: [],
                notCondition: {
                    key: "role", value: 1, check: true, checkCon: (value) => {
                        if (value?.id == 1 || value == 1) {
                            return true;
                        }
                    }
                },
                fetchOptions: {
                    url: "/brands",
                    key: "id",
                    label: "name"
                },
                serverToLocal: (values, options) => {
                    if (!values) {
                        return [];
                    }

                    return values.map(v => {
                        let value = null;
                        options.map(o => {
                            if (o.value === v) {
                                value = o;
                            }
                        });

                        if (typeof v === "string") {
                            return v;
                        } else {
                            return v.name ? { label: v.name, value: v.id } : value
                        }
                    })


                },
                localToServer: (values = null) => {
                    if (!values || !Array.isArray(values)) return [];
                    return values.map(v => typeof v === 'object' && v !== null ? (v.value ?? v.id) : v);
                },
            },
            {
                name: "Departments",
                key: "departments",
                type: 'usermultiselect',

                options: [],
                notCondition: {
                    key: "role", value: 1, check: true, checkCon: (value) => {
                        if (value?.id == 1 || value == 1) {
                            return true;
                        }
                    }
                },
                updateOptions: (options, data) => {
                    let o = [];
                    if (!options) {
                        return [];
                    }
                    const brands = data?.['brands'];
                    if (Array.isArray(brands)) {
                        options.forEach((option) => {
                            brands.forEach(v => {
                                const brandId = typeof v === 'object' && v !== null ? (v.value ?? v.id) : v;
                                if (option.filterOn === brandId) {
                                    o.push(option);
                                }
                                if (option.object?.brand === null && (data['brands'] === "" || data['brands'] === null)) {
                                    o.push(option);
                                }
                            });
                        });
                    }
                    return o;
                },
                serverToLocal: (values, options) => {
                    if (!values) {
                        return [];
                    }

                    let d = values.map(v => {
                        let value = null;
                        options.map(o => {
                            if (o.value === v) {
                                value = o;
                            }
                        });
                        if (typeof v === "string") {
                            return v;
                        }
                        else {
                            return v.name ? { label: v.name, value: v.id } : value;
                        }
                    })
                    return d;
                },

                localToServer: (values) => {
                    if (!values || !Array.isArray(values)) return [];
                    let a = [];
                    values.forEach(v =>
                        a.push(typeof v === 'object' && v !== null ? (v.value ?? v.id) : v)
                    );
                    return a;
                },
                fetchOptions: { url: "/departments", key: "id", label: "name", filterOn: 'brand' }
            },
        ]
    },
    templates: {
        name: "Upcoming Events",
        url: "templates",
        url_2: "templates",
        cancel_url: "UpCommingEvents",
        columns: [
            { name: "Event Name", key: "name" },
            {
                name: "School", accessor: (object) => {
                    return object?.brand?.name;
                }
            },

            {
                name: "Departments", accessor: (object) => {
                    return object?.department?.name;
                }
            },
            {
                name: "Date", accessor: (object) => {
                    return `${Moment(object.start_date).format(dateFormat)} to ${Moment(object.end_date).format(dateFormat)}`;
                }
            },
            // {
            //     name: "Updated At", accessor: (object) => {
            //         return Moment(object?.updated_at.substr(0, 10)).format(dateFormat)
            //     }
            // },
            {
                name: "Organizer", accessor: (object) => {
                    return object?.organized_by ? object?.organized_by : "-";
                }
            },
            {
                name: "Brochure", accessor: (object) => {
                    console.log(object);
                    return object?.Poster ? <a href={object.Poster} target="_blank">Brochure</a> : "-";
                }
            },
            // {
            //     name: "Report", accessor: (object) => {
            //         console.log(object)
            //         return (<Link to={`/report/${object.id}`}>
            //             <p style={{ color: "white", textDecorationLine: 'underline' }}>Report</p>
            //         </Link>)
            //     }
            // },
            // {
            //     name:"Child", accessor: (object) => {
            //         if(object.event_Is === "Parent"){
            //             return(<Link to={`/ChildEvent/${object.id}`}><p>{object?.templates?.length}</p></Link>)      
            //         }
            //         else{
            //             return object?.event_Is;
            //         }
            //     }
            // },
            // {
            //     name: "Register", accessor: (object) => {
            //         return (<Link to={`/registration/${object.id}/new`}>
            //             <p style={{ color: "white", textDecorationLine: 'underline' }}>Register</p>
            //         </Link>)
            //     }
            // },
            // {
            //     name: "Verification", accessor: (object) => {
            //         return (<Link to={`/verification/${object.id}`}>
            //             <p style={{ color: "white", textDecorationLine: 'underline' }}>Verification</p>
            //         </Link>)
            //     }
            // },
            // {
            //     name: "No. of Participants", accessor: (object) => {
            //         console.log(object);
            //         return (<Link to={`/registration/${object.id}`}>
            //             <p style={{ color: "white", textDecorationLine: 'underline' }}>{object?.report && object?.report[0]?.participants ? object?.report[0]?.participants:object?.registrations?.length}</p>
            //         </Link>)
            //     }
            // },
            // {
            //     name: "Create Certificates Template", accessor: (object) => {
            //         return (<Link to={`/pastEventTemplates/${object.id}`}>
            //             <p style={{ color: "white", textDecorationLine: 'underline' }}>{object?.data?.length}</p>
            //         </Link>)
            //     }
            // },
            { name: "Actions", key: "actions" },
        ],
        submitButtonText: 'Save',
        form: [
            { name: "Event Is", key: "event_Is", type: "select", options: option.EventIs, required: true, disable: true },
            {
                name: "Select Parent",
                key: "template",
                type: 'select',
                options: [],
                fetchOptions: { url: "/getTemplateData", key: "id", label: "name" },
                required: true,
                condition: { key: "event_Is", value: "Child" }
            },
            { name: "Name", key: "name", type: 'text', required: true },
            { name: "Organizer Name", required: true, key: "organized_by", type: 'text' },
            {
                name: "Select School",
                key: "brand",
                type: 'select',
                options: [],
                fetchOptions: { url: "/brands", key: "id", label: "name" },
                required: true,
            },
            {
                name: "Select Department",
                key: "department",
                type: 'select',
                options: [],
                updateOptions: (options, data) => {
                    if (!options) {
                        return [];
                    }
                    let o = [];
                    options.map(option => {
                        if (data?.brand && (option.object?.brand?.id == data?.brand
                            || option?.object?.brand?.id == data?.brand?.id)) {
                            o.push(option);
                        }
                    })
                    return o;
                },
                fetchOptions: { url: "/departments", key: "id", label: "name" },
                required: true,
            },
            {
                name: "Level of event/Activity",
                key: "activity",
                type: "select",
                options: option.activityOption,
                required: true
            },
            {
                name: "Event Type",
                key: "event_type",
                type: "select",
                options: option.eventTypeOption,
                required: true
            },
            {
                name: "Sub Type",
                key: "type",
                type: 'select',
                options: option.subEventoption,
            },
            {
                name: "Sub Type Text", key: "secoundType",
                type: 'text', condition: { key: "type", value: "Other" },
                required: true
            },
            { name: "Enable QR", key: "qr", type: 'boolean' },
            { name: "About", required: true, key: "about", type: 'textarea' },
            {
                name: "Last Date of Registration",
                key: "last_registration",
                type: "date",
                required: true,
            },
            {
                name: "Event Start Date", key: "start_date", type: 'date',
                validations:
                    [
                        { validator: 'Date', compareWith: "last_registration", error: 'Start Date should be greater than Last Date of Registration' }
                    ],
                required: true
            },
            {
                name: "Event End Date", key: "end_date", type: 'date',
                validations:
                    [
                        { validator: 'Date', compareWith: "start_date", error: 'End Date should be greater than Start Date' }
                    ],
                required: true,
            },
            { name: "Event Start time", required: true, key: "event_start_time", type: 'time' },

            { name: "Event Mode", required: true, key: "location", type: 'select', options: option.locationOption },
            { name: "Event link", key: "eventsite", type: 'url', condition: { key: "location", value: "Hybrid" }},
            {
                name: "Address Line",
                key: "address_line_1",
                type: 'textarea',
                condition: { key: "location", value: "Hybrid" },
                required: true
            },
            {
                name: "Venue",
                key: "address_line_2",
                type: 'textarea',
                condition: { key: "location", value: "Hybrid" }
            },
            {
                name: "Country",
                key: "country",
                type: 'select',
                options: option.countryOption,
                condition: { key: "location", value: "Hybrid" }
            },
            {
                name: "State",
                key: "state",
                type: 'select',
                options: option.stateOption,
                condition: { key: "location", value: "Hybrid" }
            },
            { name: "City", key: "city", type: 'text', condition: { key: "location", value: "Hybrid" } },
            { name: "Pincode", key: "pincode", type: 'text', condition: { key: "location", value: "Hybrid" } },

            {
                name: "Address",
                key: "address_line_1",
                type: 'textarea',
                condition: { key: "location", value: "Offline" },
                required: true
            },
            {
                name: "Venue",
                key: "address_line_2",
                type: 'textarea',
                condition: { key: "location", value: "Offline" }
            },
            {
                name: "Country",
                key: "country",
                type: 'select',
                options: option.countryOption,
                condition: { key: "location", value: "Offline" }
            },
            {
                name: "State",
                key: "state",
                type: 'select',
                options: option.stateOption,
                condition: { key: "location", value: "Offline" }
            },
            { name: "City", key: "city", type: 'text', condition: { key: "location", value: "Offline" } },
            { name: "Pincode", key: "pincode", type: 'text', condition: { key: "location", value: "Offline" } },
            { name: "Event link", key: "eventsite", type: 'url', condition: { key: "location", value: "Online" } },
            { name: "Website", key: "website", type: 'url' },
            { name: "Facebook URL", key: "facebook", type: 'url' },
            { name: "Linkedin URL", key: "linkedin", type: 'url' },
            {
                name: "University Charter", key: "Charter", type: "simpmultiselect", required: true,
                options: option.Charter,
            },
            {
                name: "SDGs", key: "sdg", type: "simpmultiselect", required: true,
                options: option.SDG,
            },
            {
                name: "Program Outcomes(POs)(Compulsory for all teaching Departments)", key: "PO", type: "simpmultiselect",
                options: option.PO,
            },
            { name: "Open Event", key: "open_event", type: "select", options: option.YesNo },
            { name: "Registration Type", key: "registering_type", type: "select", options: option.RegistringType },
            { name: "Total Team member", key: "max_member", condition: { key: 'registering_type', value: 'Team' } },
            { name: "Total Team member", key: "max_member", condition: { key: 'registering_type', value: 'Both' } },
            {
                name: "Registration",
                required: true,
                key: "registration_type",
                type: "select",
                options: option.Fee,
            },
            { name: "Fee", key: "fee", type: "text", condition: { key: "registration_type", value: "Paid" }, required: true },
            { name: "Limited Seats", key: "limited_seat", type: "select", required: true, options: option.YesNo },
            {
                name: "No. of Seats", type: "number", key: "total_seats", condition: { key: "limited_seat", value: "Yes" }
                , validations:
                    [
                        { validator: 'number', error: 'only numeric value is allowed' }
                    ],
                required: true
            },


            // file upload starts........................
            {
                name: "fileuploads", type: 'Multifileupload', key: "Poster", key1: "event_info", class1: "abc", class2: "bca", onchange: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('Poster', `${Api.base_url}${response[0].url}`);
                    })
                },
                onchange2: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('event_info', `${Api.base_url}${response[0].url}`);
                    })
                }
            },
            {
                name: "Notice/Circular", type: 'fileUpload', key: "Noti", key1: "Noti", class1: "abc", class2: "bca", onchange: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('Noti', `${Api.base_url}${response[0].url}`);
                    })
                },
            },
        ],
    },

    template_4: {
        name: "Past Events",
        url: "templates",
        url_2: "postEvent",
        cancel_url: "PastEvents",
        columns: [
            {
                name: "Event Name", accessor: (object) => {
                    return (<abbr style={{ textDecoration: 'none' }} class="show-user-email" title="create Report"><Link to={`/templateReports/${object.id}`}>
                        <p style={{ color: "white" }}>{object?.name}</p>
                    </Link></abbr>)
                }
            },
            // {
            //     name: "Report", accessor: (object) => {
            //         console.log(object?.report[0]?.Verified );
            //         if(object.report.length > 0 && object.report[0]?.Verified != null && object?.report[0]?.Verified != false){
            //             return "Verified";
            //         }
            //         else{
            //             return "Un-Verified";
            //         }
            //     }
            // },
            {
                name: "School", accessor: (object) => {
                    return object?.brand?.name;
                }
            },
            {
                name: "Departments", accessor: (object) => {
                    return object?.department?.name;
                }
            },
            {
                name: "Date", accessor: (object) => {
                    return `${Moment(object.start_date).format(dateFormat)} to ${Moment(object.end_date).format(dateFormat)}`;
                }
            },
            // {
            //     name: "Download Report", accessor: (object) => {
            //         return (<abbr style={{ textDecoration: 'none'}} class="show-user-email" title="Common Report"><Link to={`/eventreport/${object.id}`}>
            //             <p style={{ color: "white"}}>Common</p>
            //         </Link><Link to={`/iicreport/${object.id}`}>
            //             <p style={{ color: "white"}}>IIC</p>
            //         </Link><Link to={`/riseEventReport/${object.id}`}>
            //             <p style={{ color: "white"}}>RISE-Event</p>
            //         </Link></abbr>);
            //     }
            // },
            {
                name: "No. of Participants", accessor: (object) => {
                    return (
                        <Link to={`/registration/${object.id}`}>
                            <p style={{ color: "white", textDecorationLine: 'underline' }}>{object?.report && object?.report[0]?.participants ? object?.report[0]?.participants : object?.registrations?.length}</p>
                        </Link>)
                }
            },

            // {
            //     name: "Templates", accessor: (object) => {
            //         return (<Link to={`/pastEventTemplates/${object.id}`}>
            //             <p style={{ color: "white", textDecorationLine: 'underline' }}>{object?.data?.length}</p>
            //         </Link>)
            //     }
            // },
            // {
            //     name: "Certificate", accessor: (object) => {
            //         return (<Link to={`/templates/${object.id}/certificates`}>
            //             <p style={{ color: "white", textDecorationLine: 'underline' }}>{`${object.total_certificates}`}</p>
            //         </Link>)
            //     }
            // },
            // {
            //     name: "Report", accessor: (object) => {
            //         return (<div className="space-between">
            //         <abbr class="show-user-email" title="Download Report">
            //         <Link to={`/eventreport/${object.id}`} target="_blank">
            //             <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18   " viewBox="0 0 24 24" fill="none" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 15v4c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4M17 9l-5 5-5-5M12 12.8V2.5"/></svg>
            //         </Link></abbr>
            //         </div>)
            //     }
            // },
            {
                name: "Actions", accessor: (object) => {
                    return object?.owner?.name;
                }
            },
        ],
        form: [
            { name: "Event Is", key: "event_Is", type: "select", options: option.EventIs, required: true, disable: true },
            {
                name: "Select Parent",
                key: "template",
                type: 'select',
                options: [],
                fetchOptions: { url: "/getTemplateData", key: "id", label: "name" },
                required: true,
                condition: { key: "event_Is", value: "Child" }
            },
            { name: "Name", key: "name", type: 'text', required: true },
            { name: "Organizer Name", key: "organized_by", required: true, type: 'text' },
            {
                name: "Select School",
                key: "brand",
                type: 'select',
                options: [],
                fetchOptions: { url: "/brands", key: "id", label: "name" },
                required: true,
            },
            {
                name: "Select Department",
                key: "department",
                type: 'select',
                options: [],
                updateOptions: (options, data) => {
                    if (!options) {
                        return [];
                    }
                    let o = [];
                    options.map(option => {
                        if (data?.brand && (option.object?.brand?.id == data?.brand
                            || option?.object?.brand?.id == data?.brand?.id)) {
                            o.push(option);
                        }
                    })
                    return o;
                },
                fetchOptions: { url: "/departments", key: "id", label: "name" },
                required: true,
            },
            {
                name: "Level of event/Activity",
                key: "activity",
                type: "select",
                options: option.activityOption,
                required: true
            },
            {
                name: "Event Type",
                key: "event_type",
                type: "select",
                options: option.eventTypeOption,
                required: true
            },
            {
                name: "Sub Type",
                key: "type",
                type: 'select',
                options: option.subEventoption,
            },
            {
                name: "Sub Type Text", key: "secoundType",
                type: 'text', condition: { key: "type", value: "Other" },
                required: true
            },
            { name: "Enable QR", key: "qr", type: 'boolean' },
            { name: "About", key: "about", required: true, type: 'textarea' },
            { name: "Event Start Date", key: "start_date", type: 'date', required: true },
            {
                name: "Event End Date", key: "end_date", type: 'date',
                validations:
                    [
                        { validator: 'Date', compareWith: "start_date", error: 'End Date should be greater than Start Date' }
                    ],
                required: true,
            },
            { name: "Start time", key: "event_start_time", required: true, type: 'time' },
            {
                name: "Last Date of Registration",
                key: "last_registration",
                type: "date",
            },
            { name: "Event Mode", key: "location", type: 'select', options: option.locationOption },
            { name: "Event link", key: "eventsite", type: 'url', condition: { key: "location", value: "Hybrid" } },
            {
                name: "Address Line",
                key: "address_line_1",
                type: 'textarea',
                condition: { key: "location", value: "Hybrid" },
                required: true
            },
            {
                name: "Venue",
                key: "address_line_2",
                type: 'textarea',
                condition: { key: "location", value: "Hybrid" }
            },
            {
                name: "Country",
                key: "country",
                type: 'select',
                options: option.countryOption,
                condition: { key: "location", value: "Hybrid" }
            },
            {
                name: "State",
                key: "state",
                type: 'select',
                options: option.stateOption,
                condition: { key: "location", value: "Hybrid" }
            },
            { name: "City", key: "city", type: 'text', condition: { key: "location", value: "Hybrid" } },
            { name: "Pincode", key: "pincode", type: 'text', condition: { key: "location", value: "Hybrid" } },

            {
                name: "Address",
                key: "address_line_1",
                type: 'textarea',
                condition: { key: "location", value: "Offline" },
                required: true
            },
            {
                name: "Venue",
                key: "address_line_2",
                type: 'textarea',
                condition: { key: "location", value: "Offline" }
            },
            {
                name: "Country",
                key: "country",
                type: 'select',
                options: option.countryOption,
                condition: { key: "location", value: "Offline" }
            },
            {
                name: "State",
                key: "state",
                type: 'select',
                options: option.stateOption,
                condition: { key: "location", value: "Offline" }
            },
            { name: "City", key: "city", type: 'text', condition: { key: "location", value: "Offline" } },
            { name: "Pincode", key: "pincode", type: 'text', condition: { key: "location", value: "Offline" } },
            { name: "Event link", key: "eventsite", type: 'url', condition: { key: "location", value: "Online" } },
            { name: "Website", key: "website", type: 'url' },
            { name: "Facebook URL", key: "facebook", type: 'url' },
            { name: "Linkedin URL", key: "linkedin", type: 'url' },
            {
                name: "University Charter", key: "Charter", type: "simpmultiselect",
                options: option.Charter,
            },
            {
                name: "SDGs", key: "sdg", type: "simpmultiselect", required: true, options: option.SDG,
            },
            {
                name: "Program Outcomes(POs)(Compulsory for all teaching Departments)", key: "PO", type: "simpmultiselect", options: option.PO,
            },
            { name: "Open Event", key: "open_event", required: true, type: "select", options: option.YesNo },
            { name: "Registration Type", key: "registering_type", required: true, type: "select", options: option.RegistringType },
            { name: "Max Team member", key: "max_member", condition: { key: 'registering_type', value: 'Team' } },
            { name: "Max Team member", key: "max_member", condition: { key: 'registering_type', value: 'Both' } },
            {
                name: "Registration",
                required: true,
                key: "registration_type",
                type: "select",
                options: option.Fee,
            },
            { name: "Fee", key: "fee", type: "text", condition: { key: "registration_type", value: "Paid" }, required: true },
            { name: "Limited Seats", key: "limited_seat", type: "select", options: option.YesNo },
            { name: "No. of Seats", key: "total_seats", type: "number", required: true, condition: { key: "limited_seat", value: "Yes" } },
            // {
            //     name: "Notice", key: "notice", type: 'fileUploadpdf', onchange: (event, onChange) => {
            //         let formData = new FormData();

            //         formData.append('files', event.target.files[0]);

            //         Api.uploadFile(formData).then(response => {
            //             onChange('event_info', `${Api.base_url}${response[0].url}`);
            //         })
            //     }
            // },
            {
                name: "fileuploads", type: 'Multifileupload', key: "Poster", key1: "event_info", class1: "abc", class2: "bca", onchange: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('Poster', `${Api.base_url}${response[0].url}`);
                    })
                },
                onchange2: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('event_info', `${Api.base_url}${response[0].url}`);
                    })
                }
            },
            {
                name: "Notice/Circular", type: 'fileUpload', key: "Noti", key1: "Noti", class1: "abc", class2: "bca", onchange: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('Noti', `${Api.base_url}${response[0].url}`);
                    })
                },
            },
        ]
    },

    NewIicReport: {
        name: "Past Events IIC",
        url: "reports",
        url_2: "postEvent",
        cancel_url: "PastEvents",
        form: [
            { name: "Duration(In hrs)",title:"Activity Basic Information", key: "activityDuration", type: 'text', required: true },
            { name: "Program Type ", key: "typeOfActivity", type: 'select', options: option.IICProgramType, required: true },
            { name: "Level of Activity", key: "programType", type: 'select', options: option.ProgrammType, required: true },
            { name: "Activity Category", key: "NC", type: 'select', options: option.IICCategory, required: true },
            { name: "Lead by", key: "leadBy", type: 'select', options: option.IICLeadBy, required: true },
            { name: "Theme", key: "programTheme", type: 'select', options: option.IICTheme, required: true },
            {
                name: "Objective of the Activity (Maximum 100 Characters)", size: 100, key: "objective"
                , placeholder: "Please Enter", type: 'rowTextarea', required: true
            },
            { name: "Speaker & Activity Details",title:"Expert/speaker Details:", key: "speakerDetails", type: "addMoreOption"},
            {
                name: "Key Highlights(Short bullet point 4-5 points)", key: "oActivity"
                , placeholder: "Please Enter", type: 'rowTextarea', required: true
            },
            {
                name: "Outcome(Maximum 150 Characters)", size: 150, key: 'outcomes'
                , placeholder: "Please Enter", type: 'rowTextarea', required: true
            },
            {
                name: "Brief description of the Activity (150-200 words)", size: 200, key: "Description"
                , placeholder: "Not More than 200 Words", type: 'rowTextarea', required: true
            },
            { name: "Participation & Organizing Team", title:"Organizing Team Members Details:", key: "OrganizingTeamDetails", type: "addMoreOption"},
            { name: "No. of Staff", key: "faculty", required: true },
            { name: "No. of Student Participants", placeholder: "", key: "participants", type: "text", required: true },
            { name: "No. of External Participants", placeholder: "", key: "participantsExternal", type: "text", required: true },

            {
                name: "Attendence",title:"Media & Supporting Documents", key: "Attendence", type: 'fileUploadExcel', onchange: (event, onChange) => {

                    let formData = new FormData();

                    let attData;
                    formData.append('files', event.target.files[0]);

                    let typeName = event.target?.files[0]?.name?.split(".")[1];
                    if (!typeName?.includes("pdf")) {
                        alert("Only Pdf");
                        return;
                    }
                    if (typeName?.includes("x")) {
                        const files = event.target.files;
                        if (files.length) {
                            const file = files[0];
                            const reader = new FileReader();
                            reader.onload = (event) => {
                                const wb = read(event.target.result);
                                const sheets = wb.SheetNames;

                                if (sheets.length) {
                                    const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
                                    attData = rows
                                    Api.uploadFile(formData).then(response => {
                                        onChange("multi", { Attendence: `${Api.base_url}${response[0].url}`, Attendances: attData });
                                        console.log("Done")
                                    })
                                }
                            }
                            reader.readAsArrayBuffer(file);
                        }
                    }

                    else if (typeName?.includes("csv")) {
                        Papa.parse(event.target.files[0], {
                            header: true,
                            worker: true,
                            dynamicTyping: true,
                            complete: function (results) {
                                attData = results.data
                                Api.uploadFile(formData).then(response => {
                                    onChange("multi", { Attendence: `${Api.base_url}${response[0].url}`, Attendances: attData });
                                    console.log("Done")
                                })

                            },
                        });
                    }
                    else {
                        Api.uploadFile(formData).then(response => {
                            onChange("multi", { Attendence: `${Api.base_url}${response[0].url}`, Attendances: attData });
                            console.log("Attendence", `${Api.base_url}${response[0].url}`)
                        })
                    }
                }
            },

            { name: "Pre Activity ScreenShort",type:'fileUploadImg', key: "preActivityScreenShort", required: true, onchange: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('preActivityScreenShort', `${Api.base_url}${response[0].url}`);
                    });
                }
            },
            { name: "Post Activity ScreenShort (If available, attach newspaper articles, online news portal coverage, institutional newsletters, or Facebook posts highlighting the activity)"
                ,type:'fileUploadImg', key: "postActivityScreenShort", onchange: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('postActivityScreenShort', `${Api.base_url}${response[0].url}`);
                    });
                }
            },
            { name: "Feedback / Reflection", type:'fileUploadImg', key: "feedback", onchange: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('feedback', `${Api.base_url}${response[0].url}`);
                    });
                }
            },
            { name: "Video URL", type:"fileUploadVideo", key: "vUrl", required:true, condition: { key: "NC", value: "IIC Calendar Activity" }, onchange: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('vUrl', `${Api.base_url}${response[0].url}`);
                    });
                }
            },
            { name: "Video URL (2-3 Minute)", type:"fileUploadVideo", key: "vUrl",required:true, condition: { key: "NC", value: "Celebration Activity" }, onchange: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('vUrl', `${Api.base_url}${response[0].url}`);
                    });
                }
            },
            {
                name: "FileUpload (Max 6 images)/(size300X300)", required: true, key: "EventsPhotos", render: (comdata, onChange, data, setData, handleSpeakerChange, handleSpeakerRemoveClick, handleSpeakerAddClick) => {
                    return <div className="template-selecter"><FileUpload
                        images={data || []}
                        setImages={(l) => {
                            setData(l);
                        }}

                        News={comdata['news']}
                        setNews={(d, index) => {
                            onChange('news', d, index);
                        }}

                        screenshorts={comdata['PhotographScreenshots'] || []}
                        setScreenshorts={(d, index) => {
                            onChange('PhotographScreenshots', d, index);
                        }}

                        pushNewss={(d) => {
                            onChange("news", d);
                        }}
                    />
                    </div>
                }
            },
            { name: "Pre link",title:"Links & Financial Details", key: "preLink", type: 'text', required: true },
            { name: "Post link", key: "postLink", type: 'text' },
            { name: "Expenditure",images:'https://events.chitkara.edu.in/images/PDF_file_icon.svg.png',type:'fileUploadImg', key: "expenditure", onchange: (event, onChange) => {
                    let formData = new FormData();

                    formData.append('files', event.target.files[0]);

                    Api.uploadFile(formData).then(response => {
                        onChange('expenditure', `${Api.base_url}${response[0].url}`);
                    });
                }
            },
            
            //---------------------------------------------------------Used In All---------------------------------------------------------------------
        ]
    },

    Report: {
        name: "Past Events",
        url: "reports",
        url_2: "postEvent",
        cancel_url: "PastEvents",
        form: [
            //-------------------------------------------------------------IIC--------------------------------------------------------------------
            { name: "Type Of Activity", key: "typeOfActivity", condition: { key: "eventWith", value: "IIC" }, type: 'select', options: option.typeOfActivity, required: true },
            { name: "Program Type", key: "programType", condition: { key: "eventWith", value: "IIC" }, type: 'select', options: option.ProgrammType, required: true },
            { name: "Program Theme", key: "programTheme", condition: { key: "eventWith", value: "IIC" }, type: 'select', options: option.ProgramTheme, required: true },
            { name: "Nomenclature", key: "NC", condition: { key: "eventWith", value: "IIC" }, required: true },
            { name: "Pre Link", key: "preLink", condition: { key: "eventWith", value: "IIC" }, required: true },
            { name: "Post Link", key: "postLink", condition: { key: "eventWith", value: "IIC" } },
            { name: "No. of Faculty", key: "faculty", condition: { key: "eventWith", value: "IIC" }, required: true },
            { name: "Video URL", key: "vUrl", condition: { key: "eventWith", value: "IIC" } },

            {
                name: "Justify the Activity", key: "oActivity", condition: { key: "eventWith", value: "IIC" }
                , placeholder: "Please Enter", type: 'rowTextarea', required: true
            },

            {
                name: "Objective(Maximum 90 Characters)", size: 90, key: "objective", condition: { key: "eventWith", value: "IIC" }
                , placeholder: "Please Enter", type: 'rowTextarea', required: true
            },

            {
                name: "Description(Not More than 100 words)", size: 100, key: "Description"
                , placeholder: "Not More than 100 Words", condition: { key: "eventWith", value: "IIC" }, type: 'rowTextarea', required: true
            },

            {
                name: "Benefit of activity(Maximum 120 Characters)", size: 120, condition: { key: "eventWith", value: "IIC" }, key: 'outcomes'
                , placeholder: "Please Enter", type: 'rowTextarea', required: true
            },

            // ------------------------------------------------------------RISE-Event------------------------------------------------------------
            {
                name: "Objective(At least 3 bullet point)", key: "objective", condition: { key: "eventWith", value: "RISE-Event" }
                , placeholder: "Please Enter", type: 'rowTextarea', required: true
            },

            {
                name: "Description(Description(200 to 300)", size: 300, key: "Description", condition: { key: "eventWith", value: "RISE-Event" }
                , placeholder: "250-500 Words", type: 'rowTextarea', required: true
            },

            { name: "No. of Faculty", key: "faculty", condition: { key: "eventWith", value: "RISE-Event" } },

            { name: "No. of Participants", placeholder: "", key: "participants", type: "text", required: true },
            { name: "No. of Faculty External", key: "facultyExternal", condition: { key: "eventWith", value: "RISE-Event" } },

            { name: "No. of Participants External", placeholder: "", condition: { key: "eventWith", value: "RISE-Event" }, key: "participantsExternal", type: "text", required: true },


            // -------------------------------------------------------------Common-----------------------------------------------------------------
            {
                name: "Objective(Enter 4 to 5 bullet point)", key: "objective", condition: { key: "eventWith", value: "Common" }
                , placeholder: "Enter 4 to 5 bullet point \n1.  ....... \n2. ........", type: 'rowTextarea', required: true
            },

            {
                name: "Description(250-500 Words)", size: 500, key: "Description", condition: { key: "eventWith", value: "Common" }
                , placeholder: "250-500 Words", type: 'rowTextarea', required: true
            },

            {
                name: "OutComes(Enter 4 to 5 bullet point)", key: 'outcomes', condition: { key: "eventWith", value: "Common" }
                , placeholder: "Enter 4 to 5 bullet point \n1.  ....... \n2. ........", type: 'rowTextarea', required: true
            },

            //---------------------------------------------------------Used In All---------------------------------------------------------------------
            {
                name: "Attendence", key: "Attendence", type: 'fileUploadExcel', onchange: (event, onChange) => {

                    let formData = new FormData();

                    let attData;
                    formData.append('files', event.target.files[0]);

                    let typeName = event.target?.files[0]?.name?.split(".")[1];
                    if (!typeName?.includes("pdf")) {
                        alert("Only Pdf");
                        return;
                    }
                    if (typeName?.includes("x")) {
                        const files = event.target.files;
                        if (files.length) {
                            const file = files[0];
                            const reader = new FileReader();
                            reader.onload = (event) => {
                                const wb = read(event.target.result);
                                const sheets = wb.SheetNames;

                                if (sheets.length) {
                                    const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
                                    attData = rows
                                    Api.uploadFile(formData).then(response => {
                                        onChange("multi", { Attendence: `${Api.base_url}${response[0].url}`, Attendances: attData });
                                        console.log("Done")
                                    })
                                }
                            }
                            reader.readAsArrayBuffer(file);
                        }
                    }

                    else if (typeName?.includes("csv")) {
                        Papa.parse(event.target.files[0], {
                            header: true,
                            worker: true,
                            dynamicTyping: true,
                            complete: function (results) {
                                attData = results.data
                                Api.uploadFile(formData).then(response => {
                                    onChange("multi", { Attendence: `${Api.base_url}${response[0].url}`, Attendances: attData });
                                    console.log("Done")
                                })

                            },
                        });
                    }
                    else {
                        Api.uploadFile(formData).then(response => {
                            onChange("multi", { Attendence: `${Api.base_url}${response[0].url}`, Attendances: attData });
                            console.log("Attendence", `${Api.base_url}${response[0].url}`)
                        })
                    }
                }
            },

            {
                name: "FileUpload (Max 6 images)/(size300X300)", required: true, key: "EventsPhotos", render: (comdata, onChange, data, setData) => {
                    return <div className="template-selecter"><FileUpload
                        images={data || []}
                        setImages={(l) => {
                            setData(l);
                        }}

                        News={comdata['news']}
                        setNews={(d, index) => {
                            onChange('news', d, index);
                        }}

                        pushNewss={(d) => {
                            onChange("news", d);
                        }}
                    />
                    </div>
                }
            },


        ]
    },

    templates_2: {
        name: "Templates",
        url: "templates",
        cancel_url: "UpCommingEvents",
        columns: [{
            name: "Name", accessor: (object) => {
                return object?.TemplateName;
            }
        },
        {
            name: "Updated By", accessor: (object) => {
                return object?.Updated_By;
            }
        },
        {
            name: "Updated At", accessor: (object) => {
                return Moment(object?.Updated_At).format(dateFormat);
            }
        },
        {
            name: "Attendence", accessor: (object) => {
                return object?.Attendence;
            }
        },
        {
            name: "Action", accessor: (object) => {
                return object?.owner?.name;
            }
        },
        ],
        form: [
            { name: "TemplateName", key: "template_name", type: 'text', required: true },
            {
                name: "TemplateType",
                key: "template_type",
                type: 'conOption',
                options: option.templateTypeOption,
                required: true
            },
            {
                name: "Build Template", key: "data", render: (templateName, data, setData) => {
                    return <div className="template-selecter"><TemplateBuilder
                        TemplateName={templateName}
                        labels={data.labels || []}
                        setLabels={(l) => {
                            let d = { ...data };
                            d.labels = l;
                            setData(d);
                        }}

                        images={data.images || []}
                        setImages={(l) => {
                            let d = { ...data };
                            d.images = l;
                            setData(d);
                        }}

                        templateTexts={data.Text || []}
                        setTemplateTexts={(l) => {
                            let d = { ...data };
                            d.Text = l;
                            setData(d);
                        }}

                        backgroundImageUrl={data.backgroundImageUrl}
                        setBackgroundImageUrl={url => {
                            let d = { ...data };
                            d.backgroundImageUrl = url;
                            setData(d);
                        }
                        } /></div>
                }
            },
        ],
    },
    template_3: {
        name: 'Upcoming Events',
        url: "templates",
        url_2: "templates",
        cancel_url: "UpCommingEvents",
        columns: [
            {
                name: "Name", key: "name"
            },
            {
                name: "Start Date", accessor: (object) => {
                    return object.start_date;
                }
            },
            {
                name: "End Date", accessor: (object) => {
                    return object.end_date;
                }
            },
        ]
    },

    PastEventInfo: {
        url: 'templates',
        cancel_url: "PastEvents",
        data: [
            { name: 'Name', key: 'name', type: 'text' },
            { name: 'Description', key: 'Description', type: 'Description' },
            {
                name: 'News', key: 'Newss', type: 'News', accessor: (object) => {
                    return object?.url;
                }
            },

            { name: 'Type', key: 'type', type: 'text' },
            {
                name: 'School', key: 'brand', type: 'text', accessor: (object) => {
                    return object?.name;
                }
            },
            {
                name: 'Department', key: 'department', type: 'text', accessor: (object) => {
                    return object?.name;
                }
            },
            { name: 'Gallery', key: 'EventsPhotos', type: 'array' },
        ]
    },
    certificates: {
        url: "certificates",
        name: "Certificates",
        columns: [
            {
                name: "Name", accessor: (object) => {
                    return object?.templateData?.TemplateName;
                }
            },
            {
                name: "Event", accessor: (object) => {
                    return object?.template?.name;
                }
            },
            {
                name: "Generated By", accessor: (object) => {
                    return object?.owner?.name;
                }
            },
            {
                name: "Generated To", accessor: (object) => {
                    return <h6>{object?.data?.email}</h6>;
                }
            },
            {
                name: "Created_At", accessor: (object) => {
                    return object?.created_at?.substr(0, 10)
                }
            },
            {
                name: "Status", accessor: (object) => {
                    if (object?.bounced) {
                        return <p className="users-td-para" style={{ color: "red" }}>Bounced</p>
                    }
                    return <p className="users-td-para" style={{ color: "green" }}>Sended</p>
                }
            },
            {
                name: "Actions", key: "actions",
            },
        ],
        form: [],
        renderForm: () => {
            return <EditCertificate />;
        },
        renderActions__unused: (column, index, rowIndex, row, originalRow, onUp, onDown, onDelete, config) => {
            return <td key={'actions'}>
                <ul>
                    <li>
                        <Link to="/" onClick={e => onUp(e, rowIndex)}>
                            <img width="16px" src="../../../../images/up-arrow.png" alt="move up" />
                        </Link>
                    </li>
                    <li>
                        <Link to="/" onClick={e => onDown(e, rowIndex)}>
                            <img width="16px" src="../../../images/down-arrow.png" alt="move down" />
                        </Link>
                    </li>
                    <li>
                        <Link to={`/${config.url}/${originalRow.id}`}>
                            <img width="16px" src="../../../images/edit-icon.png" alt="edit" />
                        </Link>
                    </li>
                    <li>
                        <Link to="/" onClick={e => onDelete(e, rowIndex)}>
                            <img width="16px" src="../../../images/garbage.png" alt="edit" />
                        </Link>
                    </li>
                </ul>
            </td>;
        }
    },
    Registration: {
        url: "registrations",
        redirectUrl: "",
        name: "Certificates",
        columns: [
            {
                name: "Registration Id", accessor: (object) => {
                    return object.uuid;
                }
            },
            {
                name: "Student Name", accessor: (object) => {
                    return object.team[0].name;
                }
            },
            {
                name: "Student email", accessor: (object) => {
                    return object.team[0].email;
                }
            },
            {
                name: "Student Phone No.", accessor: (object) => {
                    return object.team[0].phone;
                }
            },
            {
                name: "Registering Type", accessor: (object) => {
                    return object.registering_type;
                }
            },
            {
                name: "Payment", accessor: (object) => {
                    return object.payment;
                }
            },
        ],
        form: [
            { name: "Event Name", key: "name", type: "text", disabled: true },

            { name: "Registration Type", key: "registering_type", type: "text", disabled: true },

            { name: 'Team Name', key: 'team_name', type: 'text', condition: { key: 'registering_type', value: 'Team' }, required: true },

            { name: "Fee", key: "fee", placeholder: "No Fee", type: "text", notCondition: { key: 'fee', value: null }, disabled: true },
        ]
    },
    Verification: {
        url: "verification",
        form:
            [
                { name: "Registration No.", key: "uuid", type: "text" }
            ]
    }
}

export default columnConfig;
